function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * AAA IDP licence number
 * 
 */
import React from 'react';
import { connect } from 'react-redux';
import { acceptTerms } from '../../actions/index';
import ErrorMessage from '../error-message/ErrorMessage';
import { SITE_CONTENT } from '../../reducers/content/Site.content';
import './AcceptTerms.scss';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export class AcceptTerms extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "accept", checked => {
      this.props.acceptTerms(checked);
    });
  }
  render() {
    const {
      acceptTermsContent,
      terms
    } = this.props;
    let errorMessage = terms.error ? 'Terms of the Privacy Policy and Terms of Use need to be agreed to.' : '';
    return /*#__PURE__*/_jsxs("div", {
      className: "acceptTerms",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "checkbox-container",
        children: [/*#__PURE__*/_jsx("input", {
          name: "terms",
          type: "checkbox",
          checked: terms.value,
          value: "1",
          onChange: e => this.accept(e.target.checked)
        }), /*#__PURE__*/_jsx("label", {
          dangerouslySetInnerHTML: {
            __html: acceptTermsContent.label
          }
        })]
      }), /*#__PURE__*/_jsx(ErrorMessage, {
        message: errorMessage,
        error: terms.error
      })]
    });
  }
}
_defineProperty(AcceptTerms, "defaultProps", {
  terms: false,
  acceptTermsContent: {
    ...SITE_CONTENT.acceptTermsContent
  }
});
const mapStateToProps = ({
  terms
}) => {
  return {
    terms
  };
};
const mapDispatchToProps = dispatch => {
  return {
    acceptTerms: value => {
      dispatch(acceptTerms(value));
    }
  };
};
const VisibleAcceptTerms = connect(mapStateToProps, mapDispatchToProps)(AcceptTerms);
export default VisibleAcceptTerms;